import React from "react";
import { LotteryDetailsPage } from "../../Components/dashboard";

const LotteryDetails = () => {
  return <LotteryDetailsPage role="admin" />;
};

export default LotteryDetails;
